import script from "./MultiSampleCard.vue?vue&type=script&setup=true&lang=js"
export * from "./MultiSampleCard.vue?vue&type=script&setup=true&lang=js"

import "./MultiSampleCard.vue?vue&type=style&index=0&id=2d6ee49a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d6ee49a"]])

export default __exports__